import React, { Fragment } from "react"
import PropTypes from "prop-types"
import RenderOptions from "./renderOptions"
import SectionOneManduUser from "./Forms/sectionOneManduUser"
import SectionTwoManduUser from "./Forms/sectionTwoManduUser"
import SectionThreeSupport from "./Forms/sectionThreeSupport"
const UserManduEdit = (props) => (
  <div>
    <Fragment>
      <RenderOptions {...props} />
      <SectionOneManduUser {...props} />
      <SectionTwoManduUser {...props} />
      <SectionThreeSupport {...props} />
    </Fragment>
  </div>
)

UserManduEdit.propTypes = { currentData: PropTypes.object }

export default UserManduEdit
